/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const es_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const de_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const nl_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const fr_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const it_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const pt_br2_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const pt_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomodoro`)
};

const ja_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポモドーロ`)
};

const zh_timer_pomodoro_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番茄钟`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_nav = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_nav(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_nav", locale)
	if (locale === "en") return en_timer_pomodoro_nav(inputs)
	if (locale === "es") return es_timer_pomodoro_nav(inputs)
	if (locale === "de") return de_timer_pomodoro_nav(inputs)
	if (locale === "nl") return nl_timer_pomodoro_nav(inputs)
	if (locale === "fr") return fr_timer_pomodoro_nav(inputs)
	if (locale === "it") return it_timer_pomodoro_nav(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_nav(inputs)
	if (locale === "pt") return pt_timer_pomodoro_nav(inputs)
	if (locale === "ja") return ja_timer_pomodoro_nav(inputs)
	return zh_timer_pomodoro_nav(inputs)
};